import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import validEmail from "../../utils/emailUtils";

const o = {
  FirstName: "",
  LastName: "",
  UserName: "",
  ContactEmail: "",
};

const FormSysAdminRegistration = () => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [submitFlag, SetSubmitFlag] = useState(false);
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState("");
  const [errEmail, SetErrEmail] = useState(false);
  const [uNameErr, SetUNameErr] = useState(false);
  const [invalidContactEmail, setInvalidContactEmail] = useState(false);

  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };

  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };
  const AddSysAdmin = async () => {
    SetSubmitFlag(true);
    SetErrCreateMsg(false);
    SetErrEmail(false);
    SetUNameErr(false);
    if (!answers.FirstName) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (!answers.LastName) {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (answers.ContactEmail === "") {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    } else if (
      answers.ContactEmail !== "" &&
      !validEmail(answers.ContactEmail)
    ) {
      SetErrEmail(true);
      return;
    } else if (answers?.UserName === "") {
      document.getElementById("UserName").scrollIntoView();
      document.getElementById("UserName").focus();
      return;
    } else if (
      answers?.UserName !== "" &&
      containsSpacesOrSpecialChars(answers?.UserName)
    ) {
      SetUNameErr(true);
      return;
      }
    if (!validEmail(answers.ContactEmail)) {
      setInvalidContactEmail(true);
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    }
    if (answers.FirstName.length > 20) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    }
    SetProcessing(true);
    let call = "/users/ProvisionPlatformUser";
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      navigate("/success-sysadmin-registration");
    } else if (
      res.status === "SERVERERROR" ||
      res.status === "REGISTRATIONERROR"
    ) {
      SetErrMsg(
        "We have encountered an system error. Please try again and contact support if the problem persists.",
      );
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => {
      clearTimeout(timer);
      SetErrCreateMsg(false);
    };
  }, [processing]);

  return (
    <div className="FormSysAdminRegistration">
      <div className="sp-pad">
        <div className="form-container">
          {/*First Name*/}
          <div className="field-wrapper field-box7 v-top">
            <label htmlFor="FirstName">First Name</label>
            <input
              type="text"
              name="FirstName"
              id="FirstName"
              className="form-control"
              autoComplete="given-name"
              onChange={(el) => {
                setAnswer("FirstName", el.target.value);
              }}
              value={answers?.FirstName}
            />
            {!answers?.FirstName && submitFlag ? (
              <div className="alert alert-danger">First name is required.</div>
            ) : null}
            {answers.FirstName.length > 20 && submitFlag ? (
              <div className="alert alert-danger">
                Cannot be more than 20 characters
              </div>
            ) : null}
          </div>
          {/*Last Name*/}
          <div className="field-wrapper field-box8 v-top">
            <label htmlFor="LastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              name="LastName"
              id="LastName"
              autoComplete="family-name"
              onChange={(el) => {
                setAnswer("LastName", el.target.value);
              }}
              value={answers?.LastName}
            />
            {!answers?.LastName && submitFlag ? (
              <div className="alert alert-danger">Last name is required.</div>
            ) : null}
          </div>
          {/*Username*/}
          <div className="field-wrapper field-box7 v-top ">
            <label htmlFor="UserName">Username</label>
            <input
              className="form-control"
              name="UserName"
              id="UserName"
              autoComplete="username"
              onChange={(el) => {
                setAnswer("UserName", el.target.value);
              }}
              value={answers?.UserName}
            />
            {!answers?.UserName && submitFlag ? (
              <div className="alert alert-danger">Username is required. </div>
            ) : null}
            {uNameErr && submitFlag ? (
              <div className="alert alert-danger">
                Please enter a valid Username with no spaces, commas, or special
                characters.
              </div>
            ) : null}
          </div>
          {/*Contact Email*/}
          <div className="field-wrapper field-box8 v-top">
            <label htmlFor="ContactEmail">Contact Email</label>
            <input
              className="form-control"
              type="email"
              name="ContactEmail"
              id="ContactEmail"
              autoComplete="email"
              placeholder="Non-Direct"
              onChange={(el) => {
                setAnswer("ContactEmail", el.target.value);
              }}
              value={answers?.ContactEmail}
            />
            {!answers?.ContactEmail && submitFlag ? (
              <div className="alert alert-danger">
                Contact email is required.
              </div>
            ) : null}
            {errEmail && submitFlag ? (
              <div className="alert alert-danger">
                Please enter a valid email name with more than 4 characters
                long, no spaces, commas, or special characters.
              </div>
            ) : null}
            {invalidContactEmail && submitFlag ? (
                <div className="alert alert-danger">
                Please enter a valid email name with more than 4 characters
                long, no spaces, commas, or special characters.
                </div>
            ) : null}
          </div>
          {errCreateMsg ? (
            <div className="alert alert-danger">{errMsg}</div>
          ) : null}
          {/*Register Action*/}
          <div className="button-register-container">
            <button
              onClick={(e) => AddSysAdmin()}
              type="button"
              className="btn btn-success"
            >
              Register
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary spacer-margin2"
              onClick={(e) => navigate("/users")}
            >
              Cancel
            </button>
            {processing && (
              <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="loader-id"
                >
                  <div className="spinner" aria-hidden="true"></div>
                  <div className="loading-text" id="loader-id">{loadingText}</div>
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormSysAdminRegistration;
